// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1QjVh","bigColWidth":"Table_bigColWidth__3jhmY","biggerColWidth":"Table_biggerColWidth__2KXgp","row":"Table_row__Iu41B","col":"Table_col__38rVo"};